import React, { Component } from 'react';
import InstagramService from '../../../services/instagram';

import './instagram-candidates.css';

class InstagramCandidates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      isLoading: true,
    };

    this.getCandidates(props);
  }

  getCandidates(props) {
    InstagramService.getCandidates(props.location.search)    
      .then((candidates) => {
        this.setState({ 
          candidates: candidates.map(c => ({
            ...c,
            approved: true
          })),
          isLoading: false
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getOnChange = (userName) => {
    return (event) => {
      this.setState((prevState) => {
        return {
          candidates: prevState.candidates.map(candidate => {
            const additionals = {};

            if (candidate.userName === userName) {
              additionals.approved = !candidate.approved;
            }

            return {
              ...candidate,
              ...additionals
            };
          })
        }
      })
    }
  }

  getImg = (imgUrl) => {
    if (!imgUrl) return '';
    return <img src={imgUrl} height='70px'/>;
  }

  onSave = () => {
    this.setState({
      isLoading: true,
    });
    
    InstagramService.saveCandidates(this.state.candidates)    
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  render() {
    const generalFields = ['userRealName', 'userName', 'followingCount', 'followersCount', 'description', ];
    
    let body = 'Processing...';
    if (this.state && this.state.candidates && !this.state.isLoading) {
      body = (
        <div>  
          <input type='button' value='Save' onClick={this.onSave}/>

          <section>
            {
              this.state.candidates.map((candidate, i) => 
                <div key={candidate.userName} 
                  className={(!candidate.approved && 'hide') || ''}
                  onClick={this.getOnChange(candidate.userName)}
                  >
                  {/* <div><label>{i + 1} out of {this.state.candidates.length}</label></div> */}
                                
                  {/* { this.getImg(candidate.imgURL) } */}

                  {
                    [
                      ...generalFields.map(field => candidate[field]).filter(x=>x), 
                      ...[(i + 1) % 50 === 0 ? `${i + 1} / ${this.state.candidates.length}` : ''].filter(x=>x)
                    ].join(' | ')
                  }
                <hr/>
              </div>
              )
            }
          </section>

          <input type='button' value='Save' onClick={this.onSave}/>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page instagram-candidates'>
        {body}
      </section>
    );
  }
}

export default InstagramCandidates;
